import { useState, useCallback } from 'react';

export const useCustomAlert = () => {
  const [alertState, setAlertState] = useState({
    show: false,
    title: 'Alert',
    message: '',
    type: 'info',
    showCancel: false,
    onConfirm: null,
    confirmText: 'OK',
    cancelText: 'Cancel'
  });

  const showAlert = useCallback(({
    title = 'Alert',
    message = '',
    type = 'info',
    showCancel = false,
    onConfirm = null,
    confirmText = 'OK',
    cancelText = 'Cancel'
  }) => {
    setAlertState({
      show: true,
      title,
      message,
      type,
      showCancel,
      onConfirm,
      confirmText,
      cancelText
    });
  }, []);

  const hideAlert = useCallback(() => {
    setAlertState(prev => ({
      ...prev,
      show: false
    }));
  }, []);

  const showSuccess = useCallback((message, title = 'Success') => {
    showAlert({ title, message, type: 'success' });
  }, [showAlert]);

  const showError = useCallback((message, title = 'Error') => {
    showAlert({ title, message, type: 'error' });
  }, [showAlert]);

  const showWarning = useCallback((message, title = 'Warning') => {
    showAlert({ title, message, type: 'warning' });
  }, [showAlert]);

  const showInfo = useCallback((message, title = 'Info') => {
    showAlert({ title, message, type: 'info' });
  }, [showAlert]);

  return {
    alertState,
    showAlert,
    hideAlert,
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
};

export const useCustomConfirm = () => {
  const [confirmState, setConfirmState] = useState({
    isOpen: false,
    title: 'Confirm Action',
    message: 'Are you sure you want to proceed?',
    confirmText: 'Yes',
    cancelText: 'No',
    type: 'warning',
    onConfirm: null,
    onCancel: null
  });

  const [isLoading, setIsLoading] = useState(false);

  const showConfirm = useCallback(({
    title = 'Confirm Action',
    message = 'Are you sure you want to proceed?',
    confirmText = 'Yes',
    cancelText = 'No',
    type = 'warning',
    onConfirm = null,
    onCancel = null
  }) => {
    setIsLoading(false);
    setConfirmState({
      isOpen: true,
      title,
      message,
      confirmText,
      cancelText,
      type,
      onConfirm: onConfirm || (() => { }),
      onCancel: onCancel || (() => { })
    });
  }, []);

  const hideConfirm = useCallback(() => {
    setConfirmState(prev => ({
      ...prev,
      isOpen: false
    }));
    setIsLoading(false);
  }, []);

  return {
    confirmState,
    showConfirm,
    hideConfirm,
    isLoading,
    setIsLoading
  };
};

